import { render } from "./LoadDetails.vue?vue&type=template&id=4a08feb4&scoped=true"
import script from "./LoadDetails.vue?vue&type=script&lang=js"
export * from "./LoadDetails.vue?vue&type=script&lang=js"

import "./LoadDetails.vue?vue&type=style&index=0&id=4a08feb4&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a08feb4"]])

export default __exports__